// extracted by mini-css-extract-plugin
module.exports = {"time":"_1ayvg"};